/**
 * What the website check found at signup, kept for the "Connect your
 * website" step that follows — it opens on the right platform's tab. Only a
 * convenience: without it the step opens on "Other".
 */
const KEY = 'ardealy.bo.signup.site';

export interface SignupSite {
    domain?: string;
    platform?: string;
    title?: string;
}

export const rememberSignupSite = (site: SignupSite) => {
    try {
        localStorage.setItem(KEY, JSON.stringify(site));
    } catch {
        /* the step falls back to "Other" */
    }
};

export const readSignupSite = (): SignupSite | null => {
    try {
        const raw = localStorage.getItem(KEY);
        return raw ? (JSON.parse(raw) as SignupSite) : null;
    } catch {
        return null;
    }
};
